// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2G25p","right":"styles_right__30F9y"};